var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3332 8.00033C13.3332 10.9458 10.9454 13.3337 7.99984 13.3337C5.05432 13.3337 2.6665 10.9458 2.6665 8.00033C2.6665 5.05481 5.05432 2.66699 7.99984 2.66699C10.9454 2.66699 13.3332 5.05481 13.3332 8.00033ZM10.1493 6.38415C10.3056 6.54036 10.3056 6.79362 10.1493 6.94983L7.48268 9.6165C7.32647 9.77271 7.0732 9.77271 6.91699 9.6165L5.85033 8.54983C5.69412 8.39363 5.69412 8.14036 5.85033 7.98415C6.00654 7.82794 6.2598 7.82794 6.41601 7.98415L7.19984 8.76797L8.39175 7.57606L9.58366 6.38415C9.73987 6.22794 9.99314 6.22794 10.1493 6.38415Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckCircle.5e14e2c7.svg";
export { ForwardRef as ReactComponent };